import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RxHamburgerMenu } from "react-icons/rx";
import { HiX } from "react-icons/hi";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = ["Home", "About", "Projects", "Services", "Journey", "Contact"];

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const handleNavClick = (id) => {
    const section = document.getElementById(id.toLowerCase());
    if (section) section.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 px-4 sm:px-6 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between rounded-full bg-gray-900/60 backdrop-blur-md px-4 sm:px-6 py-2.5 sm:py-3 shadow-lg border border-gray-700">
        {/* Logo */}
        <motion.div
          onClick={() => handleNavClick("home")}
          whileHover={{ scale: 1.05 }}
          className="text-white text-lg sm:text-xl font-extrabold cursor-pointer"
        >
          Vcode <span className="text-cyan-400">Freelance</span>
        </motion.div>

        {/* Hamburger Icon (mobile only) */}
        <div className="text-white text-2xl sm:text-3xl md:hidden cursor-pointer">
          <RxHamburgerMenu onClick={() => setMenuOpen(true)} />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <motion.button
              key={item}
              onClick={() => handleNavClick(item)}
              whileHover={{ scale: 1.1, color: "#06b6d4" }}
              className="text-white text-base font-medium transition-all"
            >
              {item}
            </motion.button>
          ))}
        </nav>
      </div>

      {/* Fullscreen Overlay Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="fixed inset-0 z-40 bg-black/60 backdrop-blur-lg flex flex-col justify-center items-center gap-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Close Button */}
            <button
              onClick={() => setMenuOpen(false)}
              className="absolute top-6 right-6 text-white text-4xl hover:text-cyan-400 transition"
            >
              <HiX />
            </button>

            {/* Navigation Links */}
            {navItems.map((item, index) => (
              <motion.button
                key={item}
                onClick={() => handleNavClick(item)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index }}
                className="text-white text-2xl sm:text-3xl font-semibold tracking-wide hover:text-cyan-400 transition duration-300"
              >
                {item}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
